// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieDisclaimer__container","inner":"CookieDisclaimer__inner","text":"CookieDisclaimer__text","right":"CookieDisclaimer__right","link":"CookieDisclaimer__link"};